import { useState, useEffect, useCallback } from 'react'
import { PinPad } from '../PinPad'
import { AdultPersonalView } from './AdultPersonalView'
import { KidPersonalView }   from './KidPersonalView'
import { TeenPersonalView }  from './TeenPersonalView'
import { useIdleTimer } from '../useIdleTimer'

export function PersonalViewWrapper({ member, data, deviceToken, idleTimeoutMs, onReturn }) {
  const [authenticated, setAuthenticated] = useState(!member.displaySettings?.display_pin)
  const [showReturnWarning, setShowReturnWarning] = useState(false)
  const [countdown, setCountdown] = useState(10)

  const isKid  = member.displaySettings?.kid_mode_enabled && member.displaySettings?.kid_mode_type === 'junior'
  const isTeen = member.displaySettings?.kid_mode_enabled && member.displaySettings?.kid_mode_type === 'teen'

  // No idle timeout for junior kids
  const effectiveTimeout = isKid ? null : idleTimeoutMs

  const handleIdle = useCallback(() => {
    if (isKid) {
      onReturn()
    } else {
      setShowReturnWarning(true)
      setCountdown(10)
    }
  }, [isKid, onReturn])

  useIdleTimer(effectiveTimeout ?? 999999999, handleIdle)

  useEffect(() => {
    if (!showReturnWarning) return
    const timer = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(timer)
          // Clear auth state before returning
          setAuthenticated(false)
          onReturn()
          return 0
        }
        return c - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [showReturnWarning, onReturn])

  if (!authenticated) {
    return (
      <PinPad
        member={member}
        deviceToken={deviceToken}
        onSuccess={() => setAuthenticated(true)}
        onBack={onReturn}
      />
    )
  }

  const viewProps = { member, data, deviceToken, onBack: onReturn }

  return (
    <>
      {isKid  ? <KidPersonalView   {...viewProps} /> :
       isTeen ? <TeenPersonalView  {...viewProps} /> :
                <AdultPersonalView {...viewProps} />}

      {/* Idle return warning */}
      {showReturnWarning && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gray-800 rounded-2xl p-6 text-center w-full max-w-xs">
            <p className="text-white text-lg font-semibold mb-1">
              Returning to family display in {countdown}s
            </p>
            <p className="text-gray-400 text-sm mb-5">Any interaction will cancel this</p>
            <button
              onClick={() => { setShowReturnWarning(false); setCountdown(10) }}
              className="bg-white text-gray-900 font-semibold px-6 py-2.5 rounded-xl hover:bg-white/90 transition-colors w-full"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  )
}
